import React, { useState, useEffect } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import _useLineCharts from '../../_useLineCharts';
import moment from 'moment';
import { tranksPlatformName } from '@/pages/intelligence/utils/topchartsUtils';
import * as echarts from 'echarts';

const Visualis: React.FC<any> = (props: any) => {
  const {
    imageType,
    segVal,
    lineData,
    rightTitle = '',
    segementTitle,
    chartType = 'line',
    ifLineChartLegendOn = false,
    sortList = ['facebook', 'ytg', 'twitch'], // 修改可视化堆叠顺序，facebook数据较少，放在第一个
    firstWeekSinceReleaseDates,
  } = props;

  // console.log('VisualisVisualis',props);

  const [chartLoading, setChartLoading] = useState(false);
  const [lineSeries, setLineSeries] = useState([]);
  const [linexAxis, setLinexAxis] = useState([]);

  // const colors = ['#9147FF', '#DD2C00', '#1877F2'];
  const colors = { Twitch: '#9147FF', Youtube: '#DD2C00', Facebook: '#1877F2' } as any;

  /** 获取lineSeriesData */
  const getLineSeries = (data: any) => {
    const _linexAxis: any = [...(firstWeekSinceReleaseDates || [])];
    const _lineSeries: any = [];
    // const sortList = tableHeaderOptions?.map((item: any) => item.value) || [];
    // 修改可视化堆叠顺序，facebook数据较少，放在第一个
    // const sortList = ['facebook', 'ytg', 'twitch'];

    // 获取完整的X轴信息，后端可能返回断续的时间
    sortList.forEach((key: any, idx: any) => {
      try {
        const _metrics = data[key]?.metrics[segVal]; // 后端返回的数据结构比较繁琐
        _metrics?.history?.forEach((_history: any) => {
          const _date = moment(_history?.date)?.format('YYYY-MM-DD');
          if (!_linexAxis?.includes(_date)) {
            _linexAxis.push(_date);
          }
        });
      } catch (err) {}
    });
    sortList.forEach((key: any) => {
      try {
        const _metrics = data[key]?.metrics[segVal]; // 后端返回的数据结构比较繁琐
        const _name = tranksPlatformName(key) || '';
        let _lineData: any = [];
        const itemHistory: string[] = [];
        _metrics?.history?.forEach((_history: any) => {
          const _date = moment(_history?.date)?.format('YYYY-MM-DD');
          itemHistory.push(_date);
          _lineData.push([_date, _history.value]);
        });
        _linexAxis.forEach((_axis: any) => {
          if (!itemHistory?.includes(_axis)) {
            // 如果不存在,则补齐横坐标数据
            // feat: 堆叠面积图为null时不要出现空白断点，用0填充（表格数据还是展示null-）
            _lineData.push([_axis, 0]);
          }
        });
        // 给数据按时间顺序排序，如果乱序的话，空数据之间会出现一条线连起来（时间没补齐）
        _lineData = _lineData.sort((a: any, b: any) => moment(a[0]) - moment(b[0]));
        _lineSeries.push({
          name: _name,
          type: 'line',
          data: _lineData,
          stack: 'Total',
          connectNulls: false,
          areaStyle: {
            opacity: 0.3,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: colors[_name],
              },
              {
                offset: 1,
                color: '#fff',
              },
            ]),
          },
          lineStyle: {
            color: colors[_name],
          },
          itemStyle: {
            color: colors[_name], // 折线点的颜色
          },
          smooth: false,
          showSymbol: false,
        });
        /** 数据断层情况 */
        const _linexAxisSort = _linexAxis.sort((a: any, b: any) => moment(a) - moment(b));
        setLinexAxis(_linexAxisSort);
        setLineSeries(_lineSeries);
      } catch (err) {}
    });
  };

  useEffect(() => {
    getLineSeries(lineData);
  }, [lineData, segVal, firstWeekSinceReleaseDates]);

  // 获取折线图hooks
  const { lineOption } = _useLineCharts({
    lineSeries,
    imageType,
    rightTitle,
    linexAxis,
    titleNow: segementTitle,
    topChartsType: 'details-streaming',
    chartType,
    // setChartLoading,
  });

  return (
    <>
      <div className="card-line">
        <ChartsIndex
          chartLoading={chartLoading}
          lineOption={lineOption}
          chartType={chartType}
          ifLineChartLegendOn={ifLineChartLegendOn}
        />
      </div>
    </>
  );
};

export default Visualis;
